module.exports = __webpack_public_path__ + "static/fonts/Arial-Bold.142301ad.ttf";